import { FC, useEffect, useMemo, useRef, useState } from 'react';
import cs from 'classnames';
import { isNotEmpty } from '@lhb/func';
import { post } from '@/common/request';
import { sectionKey, leftSection } from '../ts-config';
import { leftListSelectionDOM, leftTab } from '../../../ts-config';

import styles from './index.module.less';
import MapDrawer from '@/common/components/business/MapDrawer';
import SelectionList from './ConditionFilter/SelectionList';
import SecondMenu from './ConditionFilter/SecondMenu';
import SideBox from './ConditionFilter/SideBox';
import ChangeTab from './ChangeTab';
import LayerList from './LayerSet/LayerList';
import { useMethods } from '@lhb/hook';

/**
 * @Description 左侧筛选项和左下地图皮肤工具箱
 */
const LeftCon:FC<{
  showLeftCon, // 展示左侧抽屉
  setShowLeftCon, // 控制展示左侧抽屉
  cityProvinceInfo, // 当前城市信息
  setItemData,
  setCurSelectDistrict,
  curSelectDistrict,
  setSearchParams,
  setChecked,
  districtCluster, // 点击区聚合时保存的数据
  checked,
  isGreater1440, // 是否大屏幕1440
  isGreater1920, // 是否大于1920
  mapIns,
  isSelectDistrictRef,
  isOpenBorder,
  setIsOpenBorder,
  isOpenSubway,
  setIsOpenSubway,
  isShape,
  setViewLevel,
  requirementData,
}> = ({
  showLeftCon,
  setShowLeftCon,
  cityProvinceInfo,
  setItemData,
  setCurSelectDistrict,
  curSelectDistrict,
  setSearchParams,
  setChecked,
  districtCluster, // 点击区聚合时保存的数据
  checked,
  isGreater1440, // 是否大屏幕1440
  isGreater1920, // 是否大于1920
  mapIns,
  isSelectDistrictRef,
  isOpenBorder,
  setIsOpenBorder,
  isOpenSubway,
  setIsOpenSubway,
  isShape,
  setViewLevel,
  requirementData,
}) => {

  const requirementId = requirementData?.requirementId; // 需求id

  const [active, setActive] = useState<any>('');// 当前鼠标悬浮的菜单的一级code
  const [firstActive, setFirstActive] = useState<any>(''); // 当前鼠标悬浮的一级菜单
  const [options, setOptions] = useState<any>([]);
  const [tabActive, setTabActive] = useState<string>(leftTab.condition);
  const selectionListRef = useRef<any>(null);
  const [selectionHiddenMap, setSelectionHiddenMap] = useState<any>({ // 需要隐藏的选项
    projectOrientation: false, // 项目定位
    mallOpenYears: false, // 开业时长
    projectBrand: false, // 项目品牌
  });

  useEffect(() => {
    // https://yapi.lanhanba.com/project/602/interface/api/75991
    post('/map/lcn/placeCategory/hasProperty', { ids: checked?.placeCategory || [] }, { isMock: false, mockId: 602 }).then((res:any) => {
      setSelectionHiddenMap({
        projectOrientation: !res.hasProjectOrientation, // 是否有项目定位
        mallOpenYears: !res.hasMallOpenYears, // 是否有开业时间
        projectBrand: !res.hasProjectBrand, // 是否有项目品牌
      });
      setChecked((state) => ({
        ...state,
        projectOrientation: res.hasProjectOrientation ? state.projectOrientation : [],
        mallOpenYears: res.hasMallOpenYears ? state.mallOpenYears : [],
        projectBrand: res.hasProjectBrand ? state.projectBrand : [],
      }));
    });
  }, [checked?.placeCategory]);

  // 左侧菜单列表
  const curLeftSection = useMemo(() => {
    return leftSection?.map(item => {
      const children = item.children?.map(itm => {
        return {
          ...itm,
          count: (() => {
            if (itm.code === 'spotArea') {
              return (isNotEmpty(checked.minSpotArea) || isNotEmpty(checked.maxSpotArea)) ? 1 : 0;
            } else if (itm?.modules?.length) {
              return itm?.modules?.reduce((count, itm) => {
                return count + (checked?.[itm.code]?.length || 0);
              }, 0);
            } else {
              return checked?.[itm.code]?.length || 0;
            }
          })(),
          hidden: selectionHiddenMap[itm.code]
        };
      }).filter(itm => !itm.hidden);

      return ({
        ...item,
        children: children,
        count: item.code === 'sortRuleMenu' ? 1 : children?.reduce((pre, item) => {
          return pre + (item.count || 0);
        }, 0)
      });
    });
  }, [leftSection, checked, selectionHiddenMap]);

  const firstMenuItem = curLeftSection?.find(item => item?.code === firstActive) || {}; // 当前悬浮的一级菜单

  const handleNotHover = (event) => {
    // closest--从触发事件的元素（即 event.target）开始向上查找最接近的具有类名 "leftListSelectionDOM" 的祖先元素。如果找到了这样的祖先元素，closest 方法会返回该元素本身，否则会返回 null
    const isHovering = event?.target?.closest?.(`.${leftListSelectionDOM}`) !== null; // 检查鼠标是否在某个元素或其子元素上
    if (!isHovering) {
      setActive('');
      setFirstActive('');
    }
  };

  useEffect(() => {
    document.addEventListener('mousemove', handleNotHover);
    return () => {
      document.removeEventListener('mousemove', handleNotHover);
    };
  }, []);

  useEffect(() => {
    // 餐饮门店数、餐饮老店占比、周边人口、周边房屋均价、小区户数、小区建筑年代、商场日均客流指数
    // 这些字段全选相当于全都不选（产品青山要求，兼容现在的没数据问题导致筛选不出来问题）
    const _checked:any = {};
    Object.keys(checked || {}).map((key:any) => {
      let value:any = checked[key];
      if (
        [sectionKey.cateringStore, sectionKey.oldCateringStore, sectionKey.population, sectionKey.housePrice, sectionKey.households, sectionKey.houseYear, sectionKey.passFlow, sectionKey.labelSystemSource].includes(key)) {
        const optionIds = options?.[key].map((item) => item.id);
        if (checked?.[key]?.length === optionIds.length) {
          value = undefined;
        }
      }
      _checked[key] = value;
    });

    // 筛选右侧列表的参数，见 https://yapi.lanhanba.com/project/602/interface/api/75200
    const params = {
      requirementId, // 需求id

      sortRule: _checked?.sortRule, // 排序规则
      // 项目
      districtIds: _checked?.area, // 行政区
      placeCategoryIds: _checked?.placeCategory, // 项目类型
      projectOrientationIds: _checked?.projectOrientation, // 项目定位
      mallSizeIds: _checked?.mallSize, // 项目规模
      mallOpenYearsIds: _checked?.mallOpenYears, // 开业时长
      projectBrands: methods.getSelectionNames(_checked?.projectBrand, options.projectBrand), // 项目品牌
      flowRankIds: _checked?.flowRank, // 项目客流-市内客流对比
      dayFlows: methods.getSelectionNames(_checked?.dayFlow, options.dayFlow), // 项目客流-日均客流
      weekdayFlows: methods.getSelectionNames(_checked?.weekdayFlow, options.weekdayFlow), // 项目客流-工作日客流
      weekendFlows: methods.getSelectionNames(_checked?.weekendFlow, options.weekendFlow), // 项目客流-节假日客流
      // 点位
      spotCategoryIds: _checked?.spotCategory, // 点位类型
      minSpotArea: _checked?.minSpotArea, // 点位面积
      maxSpotArea: _checked?.maxSpotArea, // 点位面积
      spotFloors: methods.getSelectionNames(_checked?.spotFloor, options.spotFloor), // 点位楼层
      spotDayFlows: methods.getSelectionNames(_checked?.spotDayFlow, options.spotDayFlow), // 点位客流-日均客流
      spotWeekdayFlows: methods.getSelectionNames(_checked?.spotWeekdayFlow, options.spotWeekdayFlow), // 点位客流-工作日客流
      spotWeekendFlows: methods.getSelectionNames(_checked?.spotWeekendFlow, options.spotWeekendFlow), // 点位客流-节假日客流

      // 品牌参数
      preferBrandIds: _checked?.preferBrand, // 偏好品牌
      avoidBrandIds: _checked?.avoidBrand, // 避开品牌
      caseBrandIds: _checked?.caseBrand, // 案例品牌

      // 住宅特性
      householdsTypes: _checked?.households, // 户数
      housePriceTypes: _checked?.housePrice, // 房价
      houseYearTypes: _checked?.houseYear, // 建筑年代
      // 周边配套
      workTypes: _checked?.workType, // 办公
      schoolTypes: _checked?.schoolType, // 学校
      trafficTypes: _checked?.trafficType, // 交通
      scenicTypes: _checked?.scenicType, // 景区
      medicalTypes: _checked?.medicalType, // 医院
      otherTypes: _checked?.otherType, // 其他市场
    };
    setSearchParams((state) => ({ ...state, ...params }));
    setItemData({
      visible: false, // 是否显示详情
      id: null,
      detail: null, // 存放详情相关字段
      isFirst: false
    });
  }, [checked]);

  useEffect(() => {
    setChecked((state) => ({ ...state, area: [] }));
  }, [cityProvinceInfo?.id]);

  useEffect(() => {
    setViewLevel((state) => ({
      ...state,
      districtIds: checked?.[sectionKey.area]
    }));
  }, [checked?.[sectionKey.area]]);

  useEffect(() => {
    return () => {
      mapIns?.clearMap();
    };
  }, [mapIns]);

  const methods = useMethods({
    getSelectionNames(ids, list) {
      if (!ids?.length || !list?.length) {
        return [];
      }
      return ids?.reduce((res, id) => {
        const item = list?.find(item => item.id === id);
        return item ? [...res, item.name] : res;
      }, []);
    }
  });


  return <div className={styles.leftCon}>
    <MapDrawer
      placement='left'
      mapDrawerStyle={{
        width: `${isGreater1440 ? isGreater1920 ? '194px' : '10.0vw' : '146px'}`,
        top: '61px', // 12+37+12
        left: '12px',
        bottom: '5px',
        transform: showLeftCon ? 'translateX(0%)' : (isGreater1440 ? isGreater1920 ? 'translateX(-206px)' : 'translateX(calc(-10.1vw - 12px))' : 'translateX(-158px)'),
      }}
      closeConStyle={{
        top: '175px',
      }}
      visible={showLeftCon}
      setVisible={setShowLeftCon}
    >
      <div
        style={{
          height: '100vh',
          maxWidth: `calc(${isGreater1440 ? isGreater1920 ? '194px' : '10.0vw' : '146px'}`,
          width: `calc(${isGreater1440 ? isGreater1920 ? '194px' : '10.0vw' : '146px'}`,
          minWidth: `${isGreater1440 ? isGreater1920 ? '194px' : '10.0vw' : '146px'}`,
          overflow: 'hidden',
          position: 'absolute',
        }}
      >
        <div className={cs(tabActive === leftTab.condition ? styles.move : styles.recover)}>
          {/* 筛选项列表 */}
          <SelectionList
            setActive={setActive}
            selectionListRef={selectionListRef}
            setFirstActive={setFirstActive}
            firstMenuItem={firstMenuItem}
            curLeftSection={curLeftSection}
          />
          {/* 图层设置 */}
          <LayerList
            selectionListRef={selectionListRef}
            setActive={setActive}
            active={active}
            tabActive={tabActive}
            mapIns={mapIns}
            cityProvinceInfo={cityProvinceInfo}
            isOpenBorder={isOpenBorder}
            setIsOpenBorder={setIsOpenBorder}
            isOpenSubway={isOpenSubway}
            setIsOpenSubway={setIsOpenSubway}
            isShape={isShape}// 是否选中绘制商圈
          />
        </div>
      </div>
      <ChangeTab
        setTabActive={setTabActive}
        tabActive={tabActive}
        checked={checked}
        curLeftSection={curLeftSection}
      />
    </MapDrawer>

    {/* 二级菜单 */}
    <SecondMenu
      firstMenuItem={firstMenuItem}
      setActive={setActive}
      active={active}
      curLeftSection={curLeftSection}
    />

    {/* 右侧具体筛选项 */}
    <SideBox
      active={active}
      selectionListRef={selectionListRef}
      firstMenuItem={firstMenuItem}
      setChecked={setChecked}
      checked={checked}
      cityProvinceInfo={cityProvinceInfo}
      setCurSelectDistrict={setCurSelectDistrict}
      options={options}
      districtCluster={districtCluster}
      setOptions={setOptions}
      curSelectDistrict={curSelectDistrict}
      isSelectDistrictRef={isSelectDistrictRef}
      requirementData={requirementData}
    />
  </div>;
};
export default LeftCon;
